module.exports = "/_next/static/images/complaint-web-100c4378868bbf1a61a032d1a9298f15.png";